import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Button } from 'components/buttons/button';
import { ButtonSize, ButtonType } from 'components/buttons/button-types';
import { Card } from 'components/cards/card';
import { CardThemeType } from 'components/cards/card-type';

const ErrorMessageScreen = observer(({
  styles,
  retry
}: {
  styles: { [key: string]: string };
  retry: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Card
            classes={['no-margin', 'px-0 pb-0']}
            backgroundType={CardThemeType.Light}
            allowOverflow={false}
            mobilePadding={false}
          >
            <div className={`text-center cust-px-4 pt-0 ${styles.liveChatErrorCardContainer}`}>
              <i
                className={`${'icon-fix-errors'} ${styles.warning}`}
              />
              <h4 className="cust-mb-2 cust-pt-1 text-large">{t('liveChat.errorMessage.title')}</h4>

                <div className="text-regular text-center cust-mb-2">
                  {t('liveChat.errorMessage.description')}
                </div>


                <p className={`text-caption-small no-margin cust-px-4 ${'cust-mb-4'}`}>
                  {t('liveChat.errorMessage.additionalText')}
                </p>

              <p className="text-caption-small cust-px-4 cust-mt-1">{t('liveChat.errorMessage.caption')}</p>
              <div className="d-flex justify-content-center cust-mt-4">
            <Button
              meta={{
                name: t('buttons.retry'),
                title: t('buttons.retry'),
                type: ButtonType.Primary,
                size: ButtonSize.Medium
              }}
              classes={['cust-ml-1']}
              onClick={retry}
            />
          </div>
            </div>
          </Card>
    </>
  );
});
export default ErrorMessageScreen;